import { render, staticRenderFns } from "./Pay3.vue?vue&type=template&id=517967f6&"
import script from "./Pay3.vue?vue&type=script&lang=js&"
export * from "./Pay3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports